import { render, staticRenderFns } from "./chinaPaintSeries.vue?vue&type=template&id=65f7c000&scoped=true"
import script from "./chinaPaintSeries.vue?vue&type=script&lang=ts"
export * from "./chinaPaintSeries.vue?vue&type=script&lang=ts"
import style0 from "./chinaPaintSeries.vue?vue&type=style&index=0&id=65f7c000&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f7c000",
  null
  
)

export default component.exports